import React from 'react';
import ReactDOM from 'react-dom';
import UpdateNotification from './components/shared/UpdateNotification.tsx';

type Config = {
	onSuccess?: (registration: ServiceWorkerRegistration) => void;
	onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

export function register(config?: Config) {
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
  
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register(swUrl)
          .then((registration) => {
  
            registration.onupdatefound = () => {
              const installingWorker = registration.installing;
              if (installingWorker == null) return;
  
              installingWorker.onstatechange = () => {
                if (installingWorker.state === 'installed') {
                  if (navigator.serviceWorker.controller) {                    
                    // Create container for update notification
                    const container = document.createElement('div');
                    document.body.appendChild(container);
                    
                    ReactDOM.render(
                      React.createElement(UpdateNotification, {
                        onConfirm: () => {
                          window.location.reload();
                          container.remove();
                        }
                      }),
                      container
                    );

                    if (config?.onUpdate) config.onUpdate(registration);
                  } else {
                    if (config?.onSuccess) config.onSuccess(registration);
                  }
                }
              };
            };
          })
          .catch((error) => {
            console.error('Error during service worker registration:', error);
          });
      });
    } else {
      console.log('Service worker registration skipped (not in production or unsupported).');
    }
  }

export function unregister() {
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.ready
			.then((registration) => registration.unregister())
			.catch((error) =>
				console.error('Error unregistering service worker:', error)
			);
	}
}
